(() => {
  if (window.mamuleSillageBlackBooted) return;
  window.mamuleSillageBlackBooted = true;
  function init(root) {
    if (root.dataset.aaInitialized) return;
    root.dataset.aaInitialized = 'true';
    const variantsNode = root.querySelector('[data-aa-variants]');
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) { return; }
    const select = root.querySelector('select[name="id"]');
    const radios = [...root.querySelectorAll('[data-aa-variant]')];
    const orderLink = root.querySelector('[data-aa-order-link]');
    const status = root.querySelector('[data-aa-availability]');
    function update(id, notify) {
      const variant = variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      radios.forEach(r => { r.checked = r.value === String(variant.id); });
      root.querySelectorAll('[data-aa-price]').forEach(n => { n.textContent = variant.priceText; });
      root.querySelectorAll('[data-aa-compare]').forEach(n => {
        n.textContent = variant.compareText || '';
        n.hidden = !variant.compareText;
      });
      if (status) status.textContent = variant.available ? root.dataset.availableText : root.dataset.unavailableText;
      if (select && select.value !== String(variant.id)) {
        select.value = String(variant.id);
        if (notify) select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (orderLink) {
        const target = new URL(root.dataset.productUrl);
        target.searchParams.set('variant', String(variant.id));
        orderLink.href = target.toString();
      }
      if (root.dataset.mode === 'shopify' && notify) {
        const current = new URL(location.href);
        current.searchParams.set('variant', String(variant.id));
        history.replaceState(history.state, '', current);
      }
    }
    radios.forEach(r => r.addEventListener('change', () => update(r.value, true)));
    select?.addEventListener('change', () => update(select.value, false));
    const checked = radios.find(r => r.checked) || radios.find(r => !r.disabled);
    if (checked) update(checked.value, false);
    root.querySelectorAll('a[data-aa-scroll]').forEach(a => a.addEventListener('click', event => {
      const destination = document.getElementById(a.hash.slice(1));
      if (!destination) return;
      event.preventDefault();
      destination.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (a.hasAttribute('data-aa-order-scroll')) {
        const input = destination.querySelector('[data-aa-variant]:checked') || destination.querySelector('[data-aa-variant]:not(:disabled)');
        input?.focus({ preventScroll: true });
      }
    }));
    const dialog = root.querySelector('[data-aa-dialog]');
    const zoomImage = dialog?.querySelector('img');
    const zoomTitle = dialog?.querySelector('[data-aa-dialog-title]');
    if (dialog && typeof dialog.showModal === 'function') {
      root.querySelectorAll('[data-aa-zoom]').forEach(button => button.addEventListener('click', () => {
        const source = button.querySelector('img');
        if (!source || !zoomImage) return;
        zoomImage.src = button.dataset.aaZoomSrc || source.currentSrc || source.src;
        zoomImage.alt = source.alt;
        if (zoomTitle) zoomTitle.textContent = source.alt;
        dialog.showModal();
      }));
      dialog.querySelector('[data-aa-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
    }
    const sticky = root.querySelector('[data-aa-sticky]');
    const order = root.querySelector('[data-aa-order-section]');
    if (sticky && order && 'IntersectionObserver' in window) {
      const watcher = new IntersectionObserver(entries => {
        sticky.style.visibility = entries[0].isIntersecting ? 'hidden' : 'visible';
      }, { threshold: 0.15 });
      watcher.observe(order);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) watcher.disconnect();
      }, { once: true });
    }
  }
  function mount(scope) {
    if (scope.matches?.('[data-aa-landing]')) init(scope);
    scope.querySelectorAll('[data-aa-landing]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document));
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();


